function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, basedir, module) {
  return module = {
    path: basedir,
    exports: {},
    require: function (path, base) {
      return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
    }
  }, fn(module, module.exports), module.exports;
}

var browser = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  /**
   * DOM event delegator
   *
   * The delegator will listen
   * for events that bubble up
   * to the root node.
   *
   * @constructor
   * @param {Node|string} [root] The root node or a selector string matching the root node
   */

  function Delegate(root) {
    /**
     * Maintain a map of listener
     * lists, keyed by event name.
     *
     * @type Object
     */
    this.listenerMap = [{}, {}];

    if (root) {
      this.root(root);
    }
    /** @type function() */


    this.handle = Delegate.prototype.handle.bind(this); // Cache of event listeners removed during an event cycle

    this._removedListeners = [];
  }
  /**
   * Start listening for events
   * on the provided DOM element
   *
   * @param  {Node|string} [root] The root node or a selector string matching the root node
   * @returns {Delegate} This method is chainable
   */


  Delegate.prototype.root = function (root) {
    var listenerMap = this.listenerMap;
    var eventType; // Remove master event listeners

    if (this.rootElement) {
      for (eventType in listenerMap[1]) {
        if (listenerMap[1].hasOwnProperty(eventType)) {
          this.rootElement.removeEventListener(eventType, this.handle, true);
        }
      }

      for (eventType in listenerMap[0]) {
        if (listenerMap[0].hasOwnProperty(eventType)) {
          this.rootElement.removeEventListener(eventType, this.handle, false);
        }
      }
    } // If no root or root is not
    // a dom node, then remove internal
    // root reference and exit here


    if (!root || !root.addEventListener) {
      if (this.rootElement) {
        delete this.rootElement;
      }

      return this;
    }
    /**
     * The root node at which
     * listeners are attached.
     *
     * @type Node
     */


    this.rootElement = root; // Set up master event listeners

    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.addEventListener(eventType, this.handle, true);
      }
    }

    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.addEventListener(eventType, this.handle, false);
      }
    }

    return this;
  };
  /**
   * @param {string} eventType
   * @returns boolean
   */


  Delegate.prototype.captureForType = function (eventType) {
    return ['blur', 'error', 'focus', 'load', 'resize', 'scroll'].indexOf(eventType) !== -1;
  };
  /**
   * Attach a handler to one
   * event for all elements
   * that match the selector,
   * now or in the future
   *
   * The handler function receives
   * three arguments: the DOM event
   * object, the node that matched
   * the selector while the event
   * was bubbling and a reference
   * to itself. Within the handler,
   * 'this' is equal to the second
   * argument.
   *
   * The node that actually received
   * the event can be accessed via
   * 'event.target'.
   *
   * @param {string} eventType Listen for these events
   * @param {string|undefined} selector Only handle events on elements matching this selector, if undefined match root element
   * @param {function()} handler Handler function - event data passed here will be in event.data
   * @param {boolean} [useCapture] see 'useCapture' in <https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener>
   * @returns {Delegate} This method is chainable
   */


  Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
    var root;
    var listenerMap;
    var matcher;
    var matcherParam;

    if (!eventType) {
      throw new TypeError('Invalid event type: ' + eventType);
    } // handler can be passed as
    // the second or third argument


    if (typeof selector === 'function') {
      useCapture = handler;
      handler = selector;
      selector = null;
    } // Fallback to sensible defaults
    // if useCapture not set


    if (useCapture === undefined) {
      useCapture = this.captureForType(eventType);
    }

    if (typeof handler !== 'function') {
      throw new TypeError('Handler must be a type of Function');
    }

    root = this.rootElement;
    listenerMap = this.listenerMap[useCapture ? 1 : 0]; // Add master handler for type if not created yet

    if (!listenerMap[eventType]) {
      if (root) {
        root.addEventListener(eventType, this.handle, useCapture);
      }

      listenerMap[eventType] = [];
    }

    if (!selector) {
      matcherParam = null; // COMPLEX - matchesRoot needs to have access to
      // this.rootElement, so bind the function to this.

      matcher = matchesRoot.bind(this); // Compile a matcher for the given selector
    } else if (/^[a-z]+$/i.test(selector)) {
      matcherParam = selector;
      matcher = matchesTag;
    } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
      matcherParam = selector.slice(1);
      matcher = matchesId;
    } else {
      matcherParam = selector;
      matcher = Element.prototype.matches;
    } // Add to the list of listeners


    listenerMap[eventType].push({
      selector: selector,
      handler: handler,
      matcher: matcher,
      matcherParam: matcherParam
    });
    return this;
  };
  /**
   * Remove an event handler
   * for elements that match
   * the selector, forever
   *
   * @param {string} [eventType] Remove handlers for events matching this type, considering the other parameters
   * @param {string} [selector] If this parameter is omitted, only handlers which match the other two will be removed
   * @param {function()} [handler] If this parameter is omitted, only handlers which match the previous two will be removed
   * @returns {Delegate} This method is chainable
   */


  Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
    var i;
    var listener;
    var listenerMap;
    var listenerList;
    var singleEventType; // Handler can be passed as
    // the second or third argument

    if (typeof selector === 'function') {
      useCapture = handler;
      handler = selector;
      selector = null;
    } // If useCapture not set, remove
    // all event listeners


    if (useCapture === undefined) {
      this.off(eventType, selector, handler, true);
      this.off(eventType, selector, handler, false);
      return this;
    }

    listenerMap = this.listenerMap[useCapture ? 1 : 0];

    if (!eventType) {
      for (singleEventType in listenerMap) {
        if (listenerMap.hasOwnProperty(singleEventType)) {
          this.off(singleEventType, selector, handler);
        }
      }

      return this;
    }

    listenerList = listenerMap[eventType];

    if (!listenerList || !listenerList.length) {
      return this;
    } // Remove only parameter matches
    // if specified


    for (i = listenerList.length - 1; i >= 0; i--) {
      listener = listenerList[i];

      if ((!selector || selector === listener.selector) && (!handler || handler === listener.handler)) {
        this._removedListeners.push(listener);

        listenerList.splice(i, 1);
      }
    } // All listeners removed


    if (!listenerList.length) {
      delete listenerMap[eventType]; // Remove the main handler

      if (this.rootElement) {
        this.rootElement.removeEventListener(eventType, this.handle, useCapture);
      }
    }

    return this;
  };
  /**
   * Handle an arbitrary event.
   *
   * @param {Event} event
   */


  Delegate.prototype.handle = function (event) {
    var i;
    var l;
    var type = event.type;
    var root;
    var phase;
    var listener;
    var returned;
    var listenerList = [];
    var target;
    var eventIgnore = 'ftLabsDelegateIgnore';

    if (event[eventIgnore] === true) {
      return;
    }

    target = event.target; // Hardcode value of Node.TEXT_NODE
    // as not defined in IE8

    if (target.nodeType === 3) {
      target = target.parentNode;
    } // Handle SVG <use> elements in IE


    if (target.correspondingUseElement) {
      target = target.correspondingUseElement;
    }

    root = this.rootElement;
    phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2); // eslint-disable-next-line default-case

    switch (phase) {
      case 1:
        //Event.CAPTURING_PHASE:
        listenerList = this.listenerMap[1][type];
        break;

      case 2:
        //Event.AT_TARGET:
        if (this.listenerMap[0] && this.listenerMap[0][type]) {
          listenerList = listenerList.concat(this.listenerMap[0][type]);
        }

        if (this.listenerMap[1] && this.listenerMap[1][type]) {
          listenerList = listenerList.concat(this.listenerMap[1][type]);
        }

        break;

      case 3:
        //Event.BUBBLING_PHASE:
        listenerList = this.listenerMap[0][type];
        break;
    }

    var toFire = []; // Need to continuously check
    // that the specific list is
    // still populated in case one
    // of the callbacks actually
    // causes the list to be destroyed.

    l = listenerList.length;

    while (target && l) {
      for (i = 0; i < l; i++) {
        listener = listenerList[i]; // Bail from this loop if
        // the length changed and
        // no more listeners are
        // defined between i and l.

        if (!listener) {
          break;
        }

        if (target.tagName && ["button", "input", "select", "textarea"].indexOf(target.tagName.toLowerCase()) > -1 && target.hasAttribute("disabled")) {
          // Remove things that have previously fired
          toFire = [];
        } // Check for match and fire
        // the event if there's one
        //
        // TODO:MCG:20120117: Need a way
        // to check if event#stopImmediatePropagation
        // was called. If so, break both loops.
        else if (listener.matcher.call(target, listener.matcherParam, target)) {
          toFire.push([event, target, listener]);
        }
      } // TODO:MCG:20120117: Need a way to
      // check if event#stopPropagation
      // was called. If so, break looping
      // through the DOM. Stop if the
      // delegation root has been reached


      if (target === root) {
        break;
      }

      l = listenerList.length; // Fall back to parentNode since SVG children have no parentElement in IE

      target = target.parentElement || target.parentNode; // Do not traverse up to document root when using parentNode, though

      if (target instanceof HTMLDocument) {
        break;
      }
    }

    var ret;

    for (i = 0; i < toFire.length; i++) {
      // Has it been removed during while the event function was fired
      if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
        continue;
      }

      returned = this.fire.apply(this, toFire[i]); // Stop propagation to subsequent
      // callbacks if the callback returned
      // false

      if (returned === false) {
        toFire[i][0][eventIgnore] = true;
        toFire[i][0].preventDefault();
        ret = false;
        break;
      }
    }

    return ret;
  };
  /**
   * Fire a listener on a target.
   *
   * @param {Event} event
   * @param {Node} target
   * @param {Object} listener
   * @returns {boolean}
   */


  Delegate.prototype.fire = function (event, target, listener) {
    return listener.handler.call(target, event, target);
  };
  /**
   * Check whether an element
   * matches a tag selector.
   *
   * Tags are NOT case-sensitive,
   * except in XML (and XML-based
   * languages such as XHTML).
   *
   * @param {string} tagName The tag name to test against
   * @param {Element} element The element to test with
   * @returns boolean
   */


  function matchesTag(tagName, element) {
    return tagName.toLowerCase() === element.tagName.toLowerCase();
  }
  /**
   * Check whether an element
   * matches the root.
   *
   * @param {?String} selector In this case this is always passed through as null and not used
   * @param {Element} element The element to test with
   * @returns boolean
   */


  function matchesRoot(selector, element) {
    if (this.rootElement === window) {
      return ( // Match the outer document (dispatched from document)
        element === document || // The <html> element (dispatched from document.body or document.documentElement)
        element === document.documentElement || // Or the window itself (dispatched from window)
        element === window
      );
    }

    return this.rootElement === element;
  }
  /**
   * Check whether the ID of
   * the element in 'this'
   * matches the given ID.
   *
   * IDs are case-sensitive.
   *
   * @param {string} id The ID to test against
   * @param {Element} element The element to test with
   * @returns boolean
   */


  function matchesId(id, element) {
    return id === element.id;
  }
  /**
   * Short hand for off()
   * and root(), ie both
   * with no parameters
   *
   * @return void
   */


  Delegate.prototype.destroy = function () {
    this.off();
    this.root();
  };

  var _default = Delegate;
  exports["default"] = _default;
  module.exports = exports["default"];
});
var Delegate = /*@__PURE__*/ getDefaultExportFromCjs(browser);

var ModalManager = /*#__PURE__*/ function () {
  function ModalManager() {
    _classCallCheck(this, ModalManager);

    this.domDelegate = new Delegate(document.body);
    this.activeModal = document.querySelector('.modal[aria-hidden="false"]');

    this._attachListeners();
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  _createClass(ModalManager, [{
    key: "_attachListeners",
    value: function _attachListeners() {
      this._onKeyPressedListener = this._onKeyPressed.bind(this);
      this.domDelegate.on('click', '[data-action="open-modal"]', this._openModal.bind(this));
      this.domDelegate.on('click', '[data-action="close-modal"]', this._closeModal.bind(this)); // We allow any other code to force closing a modal by listening to the "modal:close" event

      document.addEventListener('modal:close', this._closeModal.bind(this));
      this._clickOutsideListener = this._checkClickOutside.bind(this); // If there is already an active modal when the page is loaded, we directly attach the listener on outside click

      if (this.activeModal) {
        document.documentElement.classList.add('is-locked');
        this.domDelegate.on('click', this._clickOutsideListener);
      }
    }
  }, {
    key: "_openModal",
    value: function _openModal(event, target) {
      var _this = this;

      var modal = document.querySelector("#".concat(target.getAttribute('aria-controls')));

      if (modal) {
        var onOpen = function onOpen(event) {
          if (event.propertyName === 'visibility') {
            modal.removeEventListener('transitionend', onOpen);
            Accessibility.trapFocus(modal, 'modal');
            _this.activeModal = modal;
          }
        };

        modal.addEventListener('transitionend', onOpen);
        modal.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('is-locked');
        this.domDelegate.on('click', this._clickOutsideListener);
        this.domDelegate.on('keyup', this._onKeyPressedListener);
        return false; // Prevent the event to be propagated to the clickOutsideListener immediately
      }
    }
  }, {
    key: "_closeModal",
    value: function _closeModal() {
      var _this2 = this;

      if (this.activeModal) {
        var onClose = function onClose(event) {
          if (event.propertyName === 'visibility') {
            _this2.activeModal.removeEventListener('transitionend', onClose);

            Accessibility.removeTrapFocus(_this2.activeModal, 'modal'); // We emit an event saying it has closed, which can give the option to do cleanup

            _this2.activeModal.dispatchEvent(new CustomEvent('modal:closed'));

            _this2.activeModal = null;
          }
        };

        this.activeModal.addEventListener('transitionend', onClose);
        this.activeModal.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('is-locked');
        this.domDelegate.off('click', this._clickOutsideListener);
        this.domDelegate.off('keyup', this._onKeyPressedListener);
      }
    }
  }, {
    key: "_checkClickOutside",
    value: function _checkClickOutside(event) {
      if (this.activeModal && (!this.activeModal.contains(event.target) || this.activeModal === event.target)) {
        this._closeModal();
      }
    }
  }, {
    key: "_onKeyPressed",
    value: function _onKeyPressed(event) {
      if (event.key === 'Escape') {
        this._closeModal();
      }
    }
  }]);

  return ModalManager;
}();

var NewsletterPopup = /*#__PURE__*/ function () {
  function NewsletterPopup(element) {
    _classCallCheck(this, NewsletterPopup);

    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.rootDelegateElement = new Delegate(document.body);
    this.options = JSON.parse(element.getAttribute('data-popup-settings')); // If the popup has been already displayed, we do not display it

    try {
      if (window.location.hash === '#newsletter-popup' && window.Theme.pageType !== 'captcha') {
        this._openPopup();
      } else if (!this.options['showOnlyOnce'] || this.options['showOnlyOnce'] && localStorage.getItem('themePopup') === null) {
        setTimeout(this._openPopup.bind(this), this.options['apparitionDelay'] * 1000);
      }
    } catch (error) { // Some browsers (especially in private mode) throw an exception when trying to access local storage, so we protect ourselves here
    }

    this._attachListeners();
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  _createClass(NewsletterPopup, [{
    key: "destroy",
    value: function destroy() {
      this.delegateElement.off();
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      this._onKeyPressedListener = this._onKeyPressed.bind(this);
      this.delegateElement.on('click', '[data-action="close-popup"]', this._closePopup.bind(this));
      this._clickOutsideListener = this._checkClickOutside.bind(this);
    }
  }, {
    key: "_openPopup",
    value: function _openPopup() {
      if (!window.Theme.isExitPopupOpen) {
        this.element.setAttribute('aria-hidden', 'false');
        localStorage.setItem('themePopup', 'true');
        window.Theme.isNewsletterPopupOpen = true;
        this.delegateElement.on('click', this._clickOutsideListener);
        this.rootDelegateElement.on('keyup', this._onKeyPressedListener);
      }
    }
  }, {
    key: "_closePopup",
    value: function _closePopup() {
      this.element.setAttribute('aria-hidden', 'true');
      window.Theme.isNewsletterPopupOpen = false;
      this.delegateElement.off('click');
      this.rootDelegateElement.off('keyup', this._onKeyPressedListener);
    }
  }, {
    key: "_checkClickOutside",
    value: function _checkClickOutside(event) {
      if (!this.element.contains(event.target) || this.element === event.target) {
        this._closePopup();
      }
    }
  }, {
    key: "_onKeyPressed",
    value: function _onKeyPressed(event) {
      if (event.key === 'Escape') {
        this._closePopup();
      }
    }
  }]);

  return NewsletterPopup;
}();

var PopupsSection = /*#__PURE__*/ function () {
  function PopupsSection() {
    var element = document.querySelector('[data-section-id="popups"]');
    var _this = this;

    _classCallCheck(this, PopupsSection);

    element.querySelectorAll('[data-popup-type]').forEach(function (popup) {
      if (popup.getAttribute('data-popup-type') === 'exit') {
        _this.exitPopup = new ExitPopup(popup);
      } else if (popup.getAttribute('data-popup-type') === 'newsletter') {
        _this.newsletterPopup = new NewsletterPopup(popup);
      }
    });
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  _createClass(PopupsSection, [{
    key: "onUnload",
    value: function onUnload() {
      if (this.exitPopup) {
        this.exitPopup.destroy();
      }

      if (this.newsletterPopup) {
        this.newsletterPopup.destroy();
      }
    }
  }, {
    key: "onBlockSelect",
    value: function onBlockSelect(event) {
      if (event.target.getAttribute('data-popup-type') === 'exit' && this.exitPopup) {
        this.exitPopup._openPopup();
      } else if (event.target.getAttribute('data-popup-type') === 'newsletter' && this.newsletterPopup) {
        this.newsletterPopup._openPopup();
      }
    }
  }, {
    key: "onBlockDeselect",
    value: function onBlockDeselect() {
      if (this.exitPopup) {
        this.exitPopup._closePopup();
      }

      if (this.newsletterPopup) {
        this.newsletterPopup._closePopup();
      }
    }
  }]);

  return PopupsSection;
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

new PopupsSection('popups');